import { connect } from "react-redux";
import _ from "underscore";

var LoadingButton = require("components/utility/LoadingButton");
var SpeechControls = require("components/writing/questions/SpeechControls");
var ReactTooltip = require("react-tooltip");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactionFeedback = require("components/support/ReactionFeedback");
var QuestionFeedback = require("components/writing/questions/QuestionFeedback");
var MultiPartSentenceStarter = require("components/writing/questions/MultiPartSentenceStarter");
var FillInTheBlank = require("components/writing/questions/FillInTheBlank");
var AnswerLengthMeter = require("components/writing/answers/AnswerLengthMeter");

var AutograderFeedback = require("lib/web/AutograderFeedback");
var Chronometer = require("lib/interface/Chronometer");
var CurrentUser = require("lib/account/CurrentUser");
var GradeLevel = require("lib/academic/GradeLevel");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");

var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var QuestionTypes = require("lib/academic/QuestionTypes");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("writing/answers/answer_writing_interface.scss");

@connect(
	(state, props) => {
		var answer = WritingSelectors.answer({ state, id: props.answerID });
		LuckyOrangeClient.tagComponent("answer_id:"+answer.id)
		var passProps = {
			answer: answer
		}
		if (answer) {
			passProps.question = WritingSelectors.question({ state, id: answer.question_id });
			passProps.book = ReadingSelectors.book({ state, id: answer.text_id });
		}

		passProps.speechControlSetting = CurrentUser.get().prefs.speech_controls;
		passProps.academicLevel = parseInt(CurrentUser.get().prefs.academic_level);
		passProps.coinHistory = _.pluck(CurrentUser.get().coin_records, "key");

		return passProps;
	}, 
	(dispatch, props) => ({
		onAnswerChange: (update) => {
			return dispatch(WritingActions.localUpdateAnswer({ id: props.answerID, update }))
		},
		createAward: (award) => {
			return dispatch(RosterActions.createAward({ award })).then(() => {
				CurrentUser.fetchCurrentUserCoinData();
			})
		},
		saveHistoryChange: (update)=>{
			return dispatch(WritingActions.updateAnswer({ id: props.answerID, update, embeds: ['answer.history'] }))
		}
	})
)
class AnswerWritingInterface extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.initialStateData();
	}
	initialStateData() {
		return {
			feedbackLoading: false,
			showQuestionChangeFeedback: false,
			lastSubmittedText: null,
			feedbackOverridden: false,
			overriddenTriggers: []
		};
	}

	reset() {
		this.setState(this.initialStateData());
		this.initChronometer();
	}

	//////////////////////////////////////////
	// Related to parsing autograder data ////
	//////////////////////////////////////////

	// Check to see if a particular filter was detected.
	hasFilter(filter, autograderData) {
		if (autograderData && autograderData.filtering) {
			var filters = _.keys(autograderData.filtering);
			return filters.includes(filter);
		} else {
			return false;
		}
	}

	// Compared autograder data to see if feedback has been removed and, if it has,
	// awards coins to the student
	checkAddressedFeedback(newAutograderData) {
		var oldAutograderData = this.currentAutograderData();
		if (!(oldAutograderData && newAutograderData &&
			oldAutograderData.assisting && newAutograderData.assisting)) {
			return false;
		}

		var previousFeedback = oldAutograderData.assisting.selected_feedback;
		var currentFeedback = newAutograderData.assisting.eligible_feedback;

		if (!currentFeedback.includes(previousFeedback)) {
			return true;
		}
		return false;
	}

	rewardAddressedFeedback() {
		if (this.isReview()) {
			var subjectType = ArbitrarySubjects.REVIEW;
		} else {
			var subjectType = ArbitrarySubjects.ANSWER;
		}

		var award = {
			type: "qunit", key:"addressed-feedback-$index",
			"dynamic": {
				"index": this.props.questionIndex,
				"title": this.props.book.title,
				"subject_type": subjectType,
				"subject_id": this.props.answerID
			}
		};

		this.props.createAward(award).then((response) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Addressed Feedback!",
				text: "Well done addressing feedback for this question!",
				icon: "ok-circle"
			});
		})
	}

	currentAutograderData() {
		return this.props.answer.recentAutograderData;
	}

	//////////////////////////////////////////
	// Feedback //////////////////////////////
	//////////////////////////////////////////

	feedbackSubs() {
		var autograderData = this.currentAutograderData();
		if (autograderData && autograderData.feedback_subs) {
			return autograderData.feedback_subs;
		}		
	}

	feedbackItems() {
		var autograderData = this.currentAutograderData();
		if (autograderData && autograderData.assisting) {
			var feedbackItems = _.map(autograderData.assisting.selected_content, (content, priority) => {
				if (!content.trigger || !_.includes(this.state.overriddenTriggers, content.trigger)) {
					return content
				}				
			})
			return _.compact(feedbackItems)
		}
	}

	showFeedback() {
		return _.any(this.feedbackItems()) && !this.isLoading();
	}

	// For feedback, check to see if we should show the coin award option.
	// Don't show if:
	// - Answer is too short to grade properly
	// - The user has already gotten all the coins today they are going to be able to get
	shouldRewardShow() {
		var autograderData = this.currentAutograderData();

		if (!autograderData) {
			return false;
		}

		// Check if answer is too short
		if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
			return false;
		}

		// Check if max amount of reward hasn't been exceeded
		var checkString = "addressed-feedback-" + this.props.questionIndex;
		var count = this.props.coinHistory.reduce((n, val) => {
			return n + (val === checkString);
		}, 0);

		return count < 2;
	}

	//////////////////////////////////////////
	// Answer meta-data //////////////////////
	//////////////////////////////////////////

	collapseDuration(currentDuration) {
		if (this.props.answer.meta_data) {
			var pastDuration = 0;
			this.props.answer.meta_data.forEach(function(data){
				pastDuration += data["duration"];
			})
		} else {
			var pastDuration = 0;
		}
		return currentDuration + pastDuration;
	}

	sessionMetaData() {
		var answer = this.props.answer;
		if (Chronometer) {
			var duration = Chronometer.getDuration()
		} else {
			var duration = 0.0
		}
		return _.extend({}, (answer.sessionMetaData || this.defaultMetaData()), {
			duration: duration
		});
	}

	defaultMetaData() {
		return {
			submission_count: 0,
			paste_detected: false,
			pasted_content: null,
			session_start: (new Date()).getTime()
		}
	}

	onPaste(e){
		var pastedText = e.clipboardData.getData('Text');
		var metaData = _.clone(this.sessionMetaData());
		metaData.pasted_content = (metaData.pasted_content || []).concat(pastedText);
		metaData.paste_detected = true;

		this.props.onAnswerChange({
			sessionMetaData: metaData,
		});
	
	}

	//////////////////////////////////////////
	// Other handlers or queries /////////////
	//////////////////////////////////////////

	// adds feedback override to metadata
	onFeedbackOverride(data, reason, e) {
		$wr.nope(e)
		this.setState({ feedbackOverridden: true, overriddenTriggers: [...this.state.overriddenTriggers, data.trigger] })
		var metaDataFeedback = { "feedback_key": data.key, "reason_key": reason, "trigger": data.trigger }
		if (this.props.answer) {
			if (this.props.answer.meta_data) {
				this.props.onAnswerChange({
					meta_data: [...this.props.answer.meta_data, metaDataFeedback]
				});
			} else {
				this.props.onAnswerChange({
					meta_data: [metaDataFeedback]
				});
			}
		}
	}

	onQuestionChange(e) {
		$wr.nope(e)
		this.props.onQuestionChange();
		if (this.props.requestFeedbackOnQuestionChange) {
			this.setState({ showQuestionChangeFeedback: true });
		}
	}

	isLoading() {
		return this.props.loading || this.state.feedbackLoading;
	}

	isReview() {
		return this.props.answer.question_type == QuestionTypes.REVIEW_QUESTION
	}
	isQuiz() {
		return !!this.props.answer.quiz_id;
	}
	isJournalActivityQuestion() {
		return !(this.isReview() || this.isQuiz());
	}

	getAnswer() {
		return this.answerBodyText();
	}
	getQuestionText() {
		return this.props.question.body;
	}

	//////////////////////////////////////////
	// Answer parts, updating and reading ////
	//////////////////////////////////////////
	updateSingleAnswerText(e) {
		this.setSingleAnswerText(e.target.value);
	}

	setSingleAnswerText(text) {
		if (text.length > MAX_ANSWER_LENGTH) {
			window.wrNotifications.triggerDropDownNotification({
				title: "This answer is too long!", icon: "pencil", text: "Please remove some text" });
			return;			
		}
		var answerParts = _.clone(this.answerParts());
		var firstBodyIndex = _.findIndex(answerParts, x => x.type == MultiPartSentenceStarter.BODY);

		if (firstBodyIndex != -1) {
			answerParts[firstBodyIndex] = { type: MultiPartSentenceStarter.BODY, text }			
		} else {
			answerParts = [{ type: MultiPartSentenceStarter.BODY, text }]
		}

		this.props.onAnswerChange({
			localParts: answerParts,
			sessionMetaData: this.sessionMetaData()
		});
	}

	updateMultiPartAnswer(parts) {
		if (_.pluck(parts, "text").join(" ").length > MAX_ANSWER_LENGTH) {
			window.wrNotifications.triggerDropDownNotification({
				title: "This answer is too long!", icon: "pencil", text: "Please remove some text" });
			return;
		}
		this.props.onAnswerChange({
			localParts: parts,
			sessionMetaData: this.sessionMetaData()
		});
	}

	answerParts() {
		return this.props.answer.localParts || this.props.answer.parts;
	}

	singleAnswerText() {
		var parts = this.answerParts();
		if (_.any(parts)) {
			return parts[0].text;
		}

		return "";
	}

	starters() {
		var starters = _.where(this.answerParts(), { type:MultiPartSentenceStarter.STARTER });
		return _.pluck(starters, "text");
	}

	hasEmptyParts() {
		var answerParts = this.answerParts();
		if (!answerParts) {
			return true;
		}
		return _.any(answerParts, (part) => {
			return (!part.text) || (part.text.trim().length == 0);
		});
	}


	answerBodyText() {
		if (!this.hasSentenceStarters()) {
			return this.singleAnswerText();
		}

		var textParts = _.map(this.answerParts(), (part) => {
			return (part.text || "").trim();
		});

		textParts = _.reject(textParts, (x) => x.length == 0);
		return textParts.join(" ");
	}

	getStarterTextLength() {
		return this.starters().join(" ").length;
	}

	hasSentenceStarters() {
		return !this.isFillInTheBlank() &&
			(this.answerParts() || []).length >= 2;
	}

	isFillInTheBlank() {
		return this.props.question.type == "fill-in-the-blank-question";
	}

	//////////////////////////////////////////
	// Submitting answers ////////////////////
	//////////////////////////////////////////

	forceSubmit() {
		LuckyOrangeClient.tagComponent("forced_quiz");
		this.onAnswerComplete(true);
	}

	normalSubmit() {
		LuckyOrangeClient.tagComponent("normal_submit");
		this.onAnswerComplete(false);
	}

	// isRevisionEligible(autograderData) {
	// 	if (autograderData && autograderData.filtering && autograderData.polarizing) {
	// 		if (_.keys(autograderData.filtering).length > 0) {
	// 			return false
	// 		}
	// 		var spellRating = (autograderData.polarizing["comm-conv-mech-spell"] || {value:0});
	// 		var gramRating = (autograderData.polarizing["comm-conv-mech-gram"] || {value:0});
	// 		var wordCountRating = (autograderData.polarizing["comm-conv-org-word-count"] || {value:0});

	// 		var Mechthreshold = 0.6;
	// 		if (spellRating.value > Mechthreshold && gramRating.value > Mechthreshold &&
	// 		 wordCountRating.value > 0.3) {
	// 			return true
	// 		}
	// 	}
	// 	return false
	// }

	updateAnswerHistory(answerData, feedbackData, addressedFeedback) {
		var oldAutograderData = this.currentAutograderData();
		var source = this.state.lastSubmittedText
		var outcome = answerData.answer

		var sourceLength = source ? source.length : 0 
		
		var newHistory = _.clone(this.props.answer.history || []);
		// prevent long answers from being submitted
		if (sourceLength < 1000 && outcome.length < 1000  && source != outcome) {
			var submissionTime = new Date().getTime()
			// if not the first submission, and we have old autograder data
			if (oldAutograderData && oldAutograderData.assisting){
				var feedbackKey = oldAutograderData.assisting.selected_feedback;
	
				var subs = this.feedbackSubs();
				var feedbackContent = oldAutograderData.assisting.selected_content;
				var firstElegibleKey = _.keys(feedbackContent).sort()[0]
				if (feedbackContent[firstElegibleKey]["content"][0]){
					var transformedContent = FeedbackFormatter.insertDynamicData(feedbackContent[firstElegibleKey]["content"][0], subs).replace(/\//g,'"');
				} else {
					var transformedContent = null
				}
			
				var revision = {
					source: this.state.lastSubmittedText,
					outcome: answerData.answer,
					feedback_key: feedbackKey,
					feedback_content: transformedContent,
					addressed: addressedFeedback,
					eligible: feedbackData.autograderData.eligible,
					delta: feedbackData.autograderData.delta,
					encrypted_data: feedbackData.autograderData.encrypted,
					submission_time: submissionTime
				}
			} else { // if no revision data, this is the first submission in the session.
				var revision = {
					source: this.state.lastSubmittedText,
					outcome: answerData.answer,
					feedback_key: null,
					feedback_content: null,
					addressed: addressedFeedback,
					eligible: feedbackData.autograderData.eligible,
					delta: feedbackData.autograderData.delta,
					encrypted_data: feedbackData.autograderData.encrypted,
					submission_time: submissionTime
				}
			}
			
			newHistory.push(revision);
			this.props.saveHistoryChange({ history: newHistory});
		}
	}
	onAnswerComplete(forceSubmit) {
		if (window.speechSynthesis) {
			window.speechSynthesis.cancel();			
		}
		if (this.hasEmptyParts()) {
			if (this.hasSentenceStarters()) {
				var errorText = "Please write at least a short response for each part of this question."
			} else {
				var errorText = "Please write at least a short response to this question.";
			}
			window.wrNotifications.triggerDropDownNotification({
				title: "We need a bit more!", icon: "pencil", text: errorText });
			return;
		}

		var answerData = { 
			answer: this.answerBodyText(),
			answerParts: this.answerParts(),
			starters: this.starters(),
			text: this.props.book,
			questionKey: this.props.question.key,
			questionText: this.props.question.body, quiz: true
		};

		const autograderData = this.currentAutograderData();
		if (autograderData && autograderData.forward && autograderData.forward.length > 0 ) {
			answerData["forward"] = autograderData.forward
		}

		this.setState({
			feedbackLoading: true, feedbackItems: null
		})

		var sessionDuration = Chronometer.getDuration();
		var metaData = _.clone(this.sessionMetaData());
		metaData.submission_count = (metaData.submission_count || 0) + 1;
		metaData.duration = (metaData.duration || 0) + sessionDuration;

		// Alexandria expects "true", not a boolean
		if(metaData.paste_detected){
			answerData.pasteDetected = "true"
		}
		
		if (this.isFillInTheBlank()) {
			var answerOptions = this.props.question.answer_options;
			if (answerOptions && answerOptions.length) {
				var text = _.findWhere(
					this.answerParts(), { type: MultiPartSentenceStarter.BODY }
				).text;
				var answerData = {
					text, 
					options: answerOptions.join(","),
					question_text: this.props.question.body
				}
				AutograderFeedback.fetchFuzzyMatch(answerData, (result) => {

					if (result.autograderData && result.autograderData.evaluating) {
						var score = result.autograderData.evaluating["final-evaluation"].value;
						var mergedParts = _.map(this.answerParts(), (part) => {
							if (part.type == MultiPartSentenceStarter.BODY) {
								return _.extend({}, part, { match: score });
							} else {
								return part;
							}
						})
					} else {
						var mergedParts = this.answerParts();
					}
					this.props.onAnswerChange({
						answerParts: mergedParts,
						localParts: mergedParts,
						recentAutograderData: result.autograderData,
						sessionMetaData: metaData
					}).then(() => {
						this.props.onComplete();
						this.setState({ feedbackLoading: false, lastSubmittedText: null});
					});

				});

			} else {
				this.props.onAnswerChange({
					sessionMetaData: metaData
				}).then(() => {
					this.props.onComplete();
					this.setState({ feedbackLoading: false, lastSubmittedText: null});
				});
			}

		} else {
			AutograderFeedback.fetch(answerData, (result) => {
				if (result && result.autograderData) {
					var addressedFeedback = this.checkAddressedFeedback(result.autograderData);
					this.updateAnswerHistory(answerData, result, addressedFeedback);
					if (this.shouldRewardShow() && addressedFeedback) {
						this.rewardAddressedFeedback();
					}
				}

				this.props.onAnswerChange({
					recentAutograderData: result.autograderData,
					sessionMetaData: metaData
				}).then(() => {
					if (_.isEmpty(this.feedbackItems()) || forceSubmit || result.noFeedback) {
						this.props.onComplete();
						this.setState({lastSubmittedText: null, feedbackLoading: false });
					} else {
						this.setState({ lastSubmittedText: answerData.answer, feedbackLoading: false });
					}
				});
			});

		}
	}

	//////////////////////////////////////////
	// Renderers /////////////////////////////
	//////////////////////////////////////////

	renderFillInTheBlankArea() {
		return (
			<FillInTheBlank key={ this.props.question.id }
				answerParts={ this.answerParts() }
				handlePasteBehaviour={ this.onPaste }
				onChange={ this.updateMultiPartAnswer } 
				speechControlSetting={ this.props.speechControlSetting }/>
		);
	}

	renderSentenceStarterArea() {
		return (
			<MultiPartSentenceStarter key={ this.props.question.id }
				answerParts={ this.answerParts() }
				handlePasteBehaviour={ this.onPaste }
				onChange={ this.updateMultiPartAnswer } 
				speechControlSetting={ this.props.speechControlSetting }/>
		);
	}

	renderTextArea() {
		// Ref is for attaching events only
		return (
			<textarea key={ this.props.question.id }
				className="form-control singleAnswer" rows="6" ref="textarea"
				value={ this.singleAnswerText() }
				onChange={ this.updateSingleAnswerText } 
				onPaste ={this.onPaste}/>
		)
	}

	renderFeedback() {
		if (this.showFeedback()) {
			var subs = this.feedbackSubs();
			var renderedItems = _.map(this.feedbackItems(), (item) => {
				var feedbackItem = FeedbackFormatter.format(_.first(item.content), subs);
				feedbackItem.data = item
				return feedbackItem
			})
			return (
				<div className="questionFeedbackBox">
					<QuestionFeedback onFeedbackOverride={ this.onFeedbackOverride } feedbackItems={ renderedItems }
						showFeedbackReward={this.shouldRewardShow()} />
				</div>
			);			
		}
	}

	renderButtons() {		
		if (this.isReview()) {
			var nextText = "Finish Review";
		} else if (this.isJournalActivityQuestion()) {
			var nextText = "Finish Question";
		} else if (this.props.hasMoreQuestions) {
			var nextText = "Next Question";
		} else {
			var nextText = "Finish Quiz";
		}

		if (this.showFeedback()) {
			var submitAnyway = (
				<LoadingButton className="btn buttonDefault submitAnyway" text={ nextText }
					onClick={ this.forceSubmit } loading={ this.isLoading() } />
			);
			var trySubmit = (
				<LoadingButton className="btn buttonPrimary checkAgain" text="Check Again"
					data-tip="After editing what you wrote, click here to get more helpful tips from Owlfonso."
					onClick={ this.normalSubmit } loading={ this.isLoading() } />
			);

		} else {
			var trySubmit = (
				<LoadingButton className="btn buttonPrimary" text={nextText}
					onClick={this.normalSubmit} loading={this.isLoading()} />
			);
		}

		return (
			<div className="buttons">
				{ submitAnyway }
				{ trySubmit }
				<ReactTooltip effect="solid" />
			</div>
		)

	}

	renderVoiceFirstSpeechControls() {
		if (this.props.speechControlSetting == "voice-first") {
			if (this.hasSentenceStarters()) {
				return (
					<div className="voiceFirstSpeechControls">
						<SpeechControls key={this.props.questionIndex} getText={ this.getAnswer } setText={ this.setSingleAnswerText }
							getTextToRead={ this.getQuestionText } toggleHighlight={ this.toggleHighlight }
							autoReadText={ true } readTextOnly={true}/>
					</div>
				);
			} else if (!this.isFillInTheBlank()) {
				return (
					<div className="voiceFirstSpeechControls">
						<SpeechControls key={this.props.questionIndex} getText={ this.getAnswer } setText={ this.setSingleAnswerText }
							getTextToRead={ this.getQuestionText } toggleHighlight={ this.toggleHighlight }
							autoReadText={ true } />
					</div>
				);
			}
		}
	}

	renderNormalSpeechControls() {
		if (!(this.hasSentenceStarters() || this.isFillInTheBlank()) && (this.props.speechControlSetting == "normal")) {
			return (
				<div className="normalSpeechControls">
					<SpeechControls key={this.props.questionIndex} getText={ this.getAnswer } setText={ this.setSingleAnswerText }
						getTextToRead={ this.getQuestionText } toggleHighlight={ this.toggleHighlight } />
				</div>
			);
		}
	}

	renderAnswerLengthMeter() {
		if (!this.props.showAnswerLengthMeter) {
			return;
		}

		var starterLength = this.getStarterTextLength();

		var answerLength = this.answerBodyText().length - starterLength;

		var charCount = GradeLevel.getRecommendedAnswerLength(this.props.academicLevel);
		var filterCount = GradeLevel.getCharCountFilter(this.props.academicLevel);

		charCount = Math.max((charCount - starterLength) * 0.8, 20);
		filterCount = Math.max(filterCount - starterLength, 20);


		return (
			<AnswerLengthMeter currentCharCount={ answerLength }
				charCount={ charCount } filterCount={ filterCount }/>
		);
	}

	renderQuestionDisplay() {
		if (this.props.onQuestionChange) {
			if (this.state.showQuestionChangeFeedback) {
				var questionChangeFeedback = (
					<ReactionFeedback where="quiz-question-change"
						textOnly={ true }
						textTitle="Why did you change the question?"
						placeholder="Because..."
						popover_position={ ReactionFeedback.POSITION_BOTTOM_RIGHT } />
				);
			}

			var changeQuestionLink = (
				<div className="changeQuestionLink">
					<a href="#" onClick={ this.onQuestionChange }>
						<Glyphicon icon="refresh" /> Change
					</a>
					{ questionChangeFeedback }
				</div>
			);
		}

		return (
			<div className="promptText clearfix">
				{ this.props.question.body } { changeQuestionLink }
			</div>
		);
	}

	render() {
		var loading = this.props.loading || this.state.feedbackLoading;

		var slideClassName = this.showFeedback() ? " slideLeft" : "";
		if (this.props.topOuterChild) {
			var topOuterContainer = (
				<div className={ "topOuterContainer" + slideClassName }>
					{ this.props.topOuterChild }
				</div>
			);
		}

		if (this.isFillInTheBlank()) {
			var writingInterface = this.renderFillInTheBlankArea();

		} else {
			var lengthMeter = this.renderAnswerLengthMeter();
			var questionDisplay = this.renderQuestionDisplay();
			if (this.hasSentenceStarters()) {
				var writingInterface = this.renderSentenceStarterArea();
			} else {
				var writingInterface = this.renderTextArea();				
			}
		}

		return (
			<div className="answerWritingInterface clearfix">
				{ topOuterContainer }
				<div className="clearfix">
					<div className={ "questionOptionBox" + slideClassName }>
						{ questionDisplay }
						{ this.renderVoiceFirstSpeechControls() }
						{ writingInterface }
						{ lengthMeter }
						<div className="controls">
							{ this.renderNormalSpeechControls() }
							{ this.renderButtons() }
						</div>
					</div>
						{ this.renderFeedback() }
				</div>
			</div>
		);
	}


	//////////////////////////////////////////
	// Component Lifecyle ////////////////////
	//////////////////////////////////////////

	initChronometer() {
		if (Chronometer) {
			Chronometer.init();
		} else {
			setTimeout(this.initChronometer.bind(this), 300)
		}
	}
	componentDidMount() {
		this.initChronometer();
		$(this.refs.textarea).bind("paste", this.handlePasteBehaviour);
	}

	componentWillUnmount() {
		Chronometer.reset();
	}
}

var MAX_ANSWER_LENGTH = 5000;

var SPELLING_FEEDBACK = 'WRITE_GRAM_SPELLING'

AnswerWritingInterface.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the answer to be displayed
	answerID: PropTypes.number.isRequired,

	// Called when the answer writing in complete (including Feedback)
	onComplete: PropTypes.func.isRequired,

	// Boolean, if true shows a loading indicator on button and blocks submitting
	loading: PropTypes.bool,

	// Setting of the speech controls, if voice first or on at all
	speechControlSetting: PropTypes.string,

	// Index of the question, or "solo" 
	questionIndex: PropTypes.oneOfType(
		[PropTypes.number, PropTypes.string]
	).isRequired,

	// True if there are more questions coming after this. If so, button should say "Continue"
	hasMoreQuestions: PropTypes.bool,

	// Allows extra content to be added above the answer textbox
	// That moves with it when feedback shows on the right
	topOuterChild: PropTypes.object,

	//   Changes the question
	onQuestionChange: PropTypes.func,
	//   Whether we ask for feedback after changing the question
	requestFeedbackOnQuestionChange: PropTypes.bool,

	//   If true, shows a meter w/ the answer length
	showAnswerLengthMeter: PropTypes.bool,

	//   If set, allows sentence starters to show
	showStarter: PropTypes.bool,

	academicLevel: PropTypes.number,

	// Data from @connect
	answer: PropTypes.object,
	question: PropTypes.object,
	book: PropTypes.object,
	coinHistory: PropTypes.array,

	// Handlers from @connect
	onAnswerChange: PropTypes.func,
	createAward: PropTypes.func

});

module.exports = AnswerWritingInterface


// WEBPACK FOOTER //
// ./modules/components/writing/answers/AnswerWritingInterface.js